import React, { FC } from 'react';
import { useTranslation } from 'next-i18next';
import ToggleDecorator from 'src/common/components/ToggleDecorator';
import Icon from 'src/common/components/IconDS22';
import { trackEvent } from 'src/common/3rdParty/tracking';
import { GA_EVENT_FILTER } from 'src/common/gaEvents';
import useStateDebounceChange from 'src/common/hooks/useStateDebounceChange';
import Typography from 'src/common/components/Typography';
import styles from './InstabookFilter.module.scss';

export type InstabookFilterProps = {
  value?: 'true' | null;
  onChange: (value: 'true' | null) => void;
};

const instabookOptionsMap = {
  yes: 'Instabook yes',
  no: 'Instabook no',
};

const GA_PARAM_INSTABOOK = 'p6';

const InstabookFilter: FC<InstabookFilterProps> = ({ value: externalValue, onChange }) => {
  const [t] = useTranslation('search-page');

  const [value, setValue] = useStateDebounceChange((checked): void => {
    onChange(checked);
    trackEvent(GA_EVENT_FILTER, {
      [GA_PARAM_INSTABOOK]: instabookOptionsMap[checked ? 'yes' : 'no'],
    });
  }, externalValue);
  return (
    <div className={styles.root}>
      <label className={styles.titleAndToggle}>
        <Typography type="h3" weight="semibold" size="heading-5">
          {t('instabook-filter-title')}
        </Typography>
        <ToggleDecorator size="large">
          <input
            checked={!!value}
            type="checkbox"
            onChange={(event) => setValue(event.target.checked ? 'true' : null)}
          />
        </ToggleDecorator>
      </label>
      <div className={styles.description}>
        <Icon id="instabook-filled" size="l" className={styles.icon} />
        <Typography type="p" size="body-m">
          {t('instabook-filter-description')}
        </Typography>
      </div>
    </div>
  );
};

export default InstabookFilter;
